import { render, staticRenderFns } from "./AddForum.vue?vue&type=template&id=0e7ded5e&"
import script from "./AddForum.vue?vue&type=script&lang=js&"
export * from "./AddForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports